import { useQuery } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { analyzeStatementsApi } from './api'

export function useAnalyzeStatements(fromDate: string, toDate: string, enabled: boolean) {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'analyze', fromDate, toDate),
    queryFn: () => analyzeStatementsApi.analyze(fromDate, toDate),
    enabled,
  })
}
